import { connect } from 'react-redux'
import ReportsSettings from '../components/ReportsSettingsView'
import { loadDevices, changeReportDevicesManual, changeReportDevicesAutomatic, selectAllManualDevices,
  selectAllAutomaticDevices } from '../modules/reports'
import moment from "moment";
import {USER_ROLES} from "../../../constants";

const mapDispatchToProps = {
  loadDevices,
  changeReportDevicesManual,
  changeReportDevicesAutomatic,
  selectAllManualDevices,
  selectAllAutomaticDevices
};

const mapStateToProps = (state) => {

  return {
    devices: _.sortBy(state.reports.devices, (d) => -d.device_id),
    selected_all_manual: state.reports.devices && state.reports.devices.length && !(_.find(state.reports.devices, (d) => !d.manual_enabled)),
    selected_all_automatic: state.reports.devices && state.reports.devices.length && !(_.find(state.reports.devices, (d) => !d.automatic_enabled)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportsSettings)


// WEBPACK FOOTER //
// ./src/components/Reports/containers/ReportsSettingsContainer.js